module.exports = __webpack_public_path__ + "img/744.2b529097.jpg";